import Vue from 'vue'
import qs from 'qs'
import { vservice } from '@niknevis/vue-modules'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import { ObjFacade } from '@/modules/shared/helpers/facades/obj'

@vservice()
export class InertiaQueryParamsService {
  private get url() {
    return Vue.prototype.$page.url
  }

  private parse() {
    const index = this.url.indexOf('?')
    if (index < 0 || index === this.url.length) return {}
    return qs.parse(this.url.substring(index + 1))
  }

  public get params() {
    return this.parse()
  }

  public set params(value) {
    this.setParams(value)
  }

  public setParams(params: Record<string, any>) {
    return Inertia.get(window.location.pathname, {
      ...ObjFacade.filter(this.params, (_, key) => !(key in params)),
      ...ObjFacade.filter(params, (value) => value != null)
    }, {
      preserveState: true,
      preserveScroll: false
    })
  }

  public setParam(key: string, value: any) {
    return this.setParams({
      ...this.params,
      [key]: value
    })
  }

  public setParamOptimised(key: string, value: any) {
    if (this.params[key] === value) return
    return this.setParam(key, value)
  }

  public batchSetParams(params: object) {
    return this.setParams({
      ...this.params,
      ...params
    })
  }
}
